import {
  USQCPPage,
  UKQCPPage,
  ReferralPage,
  AgentReferralPage,
  QuestionnairePage,
  ShowcasePage,
  PostQuoteQuestionnairePage,
  RecommendationsPage,
  ExplanationPage,
  CombinedPaymentPage,
  QuoteDetailsPage,
  ExpiredPage,
  MtaSummaryPage,
  MtaStartDatePage,
  RfqNotCompatiblePage,
  PolicyNotRenewablePage,
  PolicyAlreadyRenewedPage,
  UKDirectDebitPage,
  UKPaymentConfirmationPage,
  UKStripePaymentPage,
  USOffPlatformPaymentConfirmationPage,
  USPaymentConfirmationPage,
  ReturningCustomerPrepopPage,
} from "@simplybusiness/mobius-journey";
import DevTools from "../packs/components/DevTools";

export const pageComponents = {
  ReferralPage,
  USQCPPage,
  UKQCPPage,
  AgentReferralPage,
  QuestionnairePage,
  PostQuoteQuestionnairePage,
  ShowcasePage,
  RecommendationsPage,
  ExplanationPage,
  CombinedPaymentPage,
  QuoteDetailsPage,
  ExpiredPage,
  MtaSummaryPage,
  MtaStartDatePage,
  RfqNotCompatiblePage,
  PolicyNotRenewablePage,
  PolicyAlreadyRenewedPage,
  UKDirectDebitPage,
  UKPaymentConfirmationPage,
  UKStripePaymentPage,
  USOffPlatformPaymentConfirmationPage,
  USPaymentConfirmationPage,
  ReturningCustomerPrepopPage,
};

export const utilityComponents = {
  DevTools,
};
